import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { DynamicText } from './api/dynamixText';
import {
  ChangePasswordForm,
  CreateAccountForm,
  LoginForm,
  ResetPasswordForm,
} from './components';
import LandingPage from './components/landing-page/LandingPage';
import SubscribeForm from './components/login-form/SubscribeForm';
import { SingleCard } from './layouts';
import LandingCard from './layouts/landing-card/landing-card';
import BigCard from './layouts/single-card/big-card';
import { ASZFPage, GDPRPage } from './pages';
import { useScreenSizeClass } from './utils/media-query';
import ProcessOrderForm from './pages/order/processOrder';

export default function UnauthenticatedContent() {
  const screenSizeClass = useScreenSizeClass();
  return (
    <Routes>
      <Route
        path='/subscribe'
        element={
          <BigCard title='Csatlakozz közösségünkhöz'>
            <SubscribeForm />
          </BigCard>
        }
      />
      <Route
        path='/processOrder'
        element={
          <BigCard title='Profil létrehozása'>
            <ProcessOrderForm />
          </BigCard>
        }
      />
      <Route
        path='/login'
        element={
          <SingleCard title='Belépés tagoknak'>
            <LoginForm />
          </SingleCard>
        }
      />
      <Route
        path='/create-account'
        element={
          <SingleCard title='Regisztráció'>
            <CreateAccountForm />
          </SingleCard>
        }
      />

      <Route
        path='/reset-password'
        element={
          <SingleCard
            title='Jelszó visszaállítás'
            description='Add meg az e-mail címet amellyel regisztráltál nálunk erre küldünk egy linket melynek segítségével új jelszót állíthatsz be.'
          >
            <ResetPasswordForm />
          </SingleCard>
        }
      />
      <Route
        path='/change-password/:recoveryCode'
        element={
          <SingleCard title='Jelszó módosítás'>
            <ChangePasswordForm />
          </SingleCard>
        }
      />
      <Route
        path='/start'
        element={
          <LandingCard
            title={DynamicText('PAGE_TITLE')}
            description={DynamicText('PAGE_TITLE_SUB')}
          >
            <LandingPage />
          </LandingCard>
        }
      />
      {/*
      <Route
        path='/preview'
        element={
          <LandingCard title='Videóink'>
            <VideoPreview />
          </LandingCard>
        }
      />
      */}
      <Route path='/aszf' element={<ASZFPage />} />
      <Route path='/gdpr' element={<GDPRPage />} />
      <Route path='*' element={<Navigate to={'/start'} />}></Route>
    </Routes>
  );
}
